import { Component, Input, NgZone, OnInit, ViewChild, ViewEncapsulation, ElementRef, Output, EventEmitter } from '@angular/core';
import { AgmCoreModule, AgmMarker, MapsAPILoader } from '@agm/core';
import { } from '@types/googlemaps';

@Component({
    selector: 'google-map',
    templateUrl: './google-map.component.html',
    styleUrls: ['./google-map.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class GoogleMapComponent implements OnInit {
    @ViewChild("searchPlace")
    public searchElementRef: ElementRef;

    @Input()
    public canEdit: Boolean = false;

    private _placeId: string;

    @Input()
    set placeId(value: string) {
        if (value != null && value != '') {
            this.mapsAPILoader.load().then(() => {
                this.geocoder = new google.maps.Geocoder();
                this.geocoder.geocode({ 'placeId': value },
                    (results, status) => {
                        this.ngZone.run(() => {
                            if (results[0]) {
                                this.searchString = results[0].formatted_address;
                                this.latitude = results[0].geometry.location.lat();
                                this.longitude = results[0].geometry.location.lng();

                                if (this._placeId == null) {
                                    this.mapLatitude = this.latitude;
                                    this.mapLongitude = this.longitude;
                                }

                                this.zoom = 15;
                            }

                            this._placeId = value;
                            this.placeIdChange.emit(this._placeId);
                        });
                    });
            });
        } else {
            this._placeId = value;
            this.placeIdChange.emit(this._placeId);
        }
    }
    
    get placeId(): string {
        return this._placeId;
    }

    private searchString: string;
    private mapLatitude: number;
    private mapLongitude: number;
    private latitude: number;
    private longitude: number;
    private zoom: number = 6;

    private geocoder: any;

    @Output() placeIdChange: EventEmitter<String>;
    constructor(
        private mapsAPILoader: MapsAPILoader,
        private ngZone: NgZone) {
        this.placeIdChange = new EventEmitter<String>();
    }

    ngOnInit() {
        this.setCurrentPosition();

        this.mapsAPILoader.load().then(() => {
            this.geocoder = new google.maps.Geocoder();
            let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {});
            autocomplete.addListener("place_changed", () => {
                this.ngZone.run(() => {
                    //get the place result
                    let place: google.maps.places.PlaceResult = autocomplete.getPlace();

                    //verify result
                    if (place.geometry === undefined || place.geometry === null) {
                        return;
                    }

                    //set latitude, longitude and zoom
                    this.latitude = this.mapLatitude = place.geometry.location.lat();
                    this.longitude = this.mapLongitude = place.geometry.location.lng();
                });
            });
        });
    }

    onMapClick($event) {
        if (this.canEdit == false) return;

        this.latitude = $event.coords.lat;
        this.longitude = $event.coords.lng;

        let latLng = new google.maps.LatLng(this.latitude, this.longitude);

        this.geocoder.geocode({ "latLng": latLng }, (results, status) => {
            this.ngZone.run(() => {
                if (status === google.maps.GeocoderStatus.OK) {
                    if (results[0]) {
                        var place = results[0];
                        this.searchString = place.formatted_address;
                        this.placeId = place.place_id;
                    }
                }
            });
        });
    }

    private setCurrentPosition() {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition((position) => {
                this.mapLatitude = position.coords.latitude;
                this.mapLongitude = position.coords.longitude;
            });
        }
    }
}



// WEBPACK FOOTER //
// ./Angular/app/_common/google-map/google-map.component.ts